module.exports = __webpack_public_path__ + "img/haft-poznan-01.345a124e.jpg";